import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3";
import { fnThrowError } from "Utilities/fnReportError";

const setLanguage = async ({ language }) => {
  const endpoint = `/user/setLanguage`;

  const fetchFunction = new FnrFetch3(endpoint, { language });
  const response = await fetchFunction.post(endpoint).catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

const contactUs = async ({
  message,
  givingInquiry,
  generalInquiry,
  flocknoteSupport,
  signupListID,
  noteID,
}) => {
  const endpoint = `/network/contactUs`;

  const fetchFunction = new FnrFetch3(endpoint, {
    message,
    givingInquiry,
    generalInquiry,
    flocknoteSupport,
    signupListID,
    noteID,
  });
  const response = await fetchFunction.post(endpoint).catch((err) => {
    fnThrowError({
      message: err?.message || `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

const prayerRequest = async ({ message }) => {
  const endpoint = `/network/prayerRequest`;

  const fetchFunction = new FnrFetch3(endpoint, {
    message,
  });
  const response = await fetchFunction.post(endpoint).catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

const getOtherNetworks = async () => {
  const endpoint = `/user/getOtherNetworks`;

  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.post(endpoint).catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

const logout = async () => {
  const endpoint = "/logout";

  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.post(endpoint).catch((err) => {
    return err;
  });

  return response;
};

export { setLanguage, getOtherNetworks, logout, contactUs, prayerRequest };
